export default __webpack_public_path__ + "drupal.a98c2483.png";